export default "__VITE_PUBLIC_ASSET__0f234de6__"